export default "__VITE_ASSET__Cxh_MYnz__"